import { InvestorDetailsEntityTypeEnum } from '../../types';
import CommitmentsTable from './table/table';

interface CommitmentsTabProps {
  entityType: InvestorDetailsEntityTypeEnum;
}

export const CommitmentsTab = ({ entityType }: CommitmentsTabProps) => {
  return <CommitmentsTable entityType={entityType} />;
};
